import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0B0B0B] border-t border-[#D4AF37]/20">
      <div className="container-luxury py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="/images/deus-logo.png" 
              alt="Deus Estate" 
              className="h-16 w-auto mb-6"
            />
            <p className="text-[#A9A9A9] text-sm leading-relaxed mb-4">
              Информираният избор при недвижими имоти и инвестиции
            </p>
            <p className="text-[#D4AF37] text-xs font-semibold tracking-wider">
              ИНФОРМИРАНИЯТ ИЗБОР
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-[#F6F2E8] font-serif text-lg font-semibold mb-6">Контакти</h3>
            <ul className="space-y-4">
              <li>
                <a 
                  href="mailto:zaharii.stoyanov@deusestate.com" 
                  className="flex items-start space-x-3 text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300 group"
                >
                  <Mail size={18} className="mt-0.5 flex-shrink-0 group-hover:text-[#D4AF37]" />
                  <span className="text-sm">zaharii.stoyanov@deusestate.com</span>
                </a>
              </li>
              <li>
                <a 
                  href="tel:+359877500793" 
                  className="flex items-start space-x-3 text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300 group"
                >
                  <Phone size={18} className="mt-0.5 flex-shrink-0 group-hover:text-[#D4AF37]" />
                  <span className="text-sm">+359 877 500 793</span>
                </a>
              </li>
              <li className="flex items-start space-x-3 text-[#A9A9A9]">
                <MapPin size={18} className="mt-0.5 flex-shrink-0" />
                <span className="text-sm">гр. София, ул. Гурко 16</span>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-[#F6F2E8] font-serif text-lg font-semibold mb-6">Услуги</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-sm text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300">
                  Недвижими имоти
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300">
                  Консултации и анализи
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300">
                  Право и финанси
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300">
                  Строителство
                </Link>
              </li>
            </ul>
          </div>

          {/* Additional Links */}
          <div>
            <h3 className="text-[#F6F2E8] font-serif text-lg font-semibold mb-6">Бързи връзки</h3>
            <ul className="space-y-3 mb-6">
              <li>
                <Link to="/insights" className="text-sm text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300">
                  Информираният избор
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300">
                  За нас
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300">
                  Контакти
                </Link>
              </li>
            </ul>

            {/* Social Links */}
            <div className="flex space-x-4">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#D4AF37]/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-[#A9A9A9]">
              © {currentYear} Deus Estate. Всички права запазени.
            </p>
            <div className="flex flex-wrap justify-center gap-6">
              <Link to="/privacy" className="text-sm text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300">
                Политика за поверителност
              </Link>
              <Link to="/cookies" className="text-sm text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300">
                Бисквитки
              </Link>
              <Link to="/terms" className="text-sm text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300">
                Общи условия
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
